module.exports = __webpack_public_path__ + "static/media/reserch_products_cn02.de41e969.png";